import { values } from 'ramda'

import { FinanceReportType } from './finances'

// отчеты сделанные по 3й версии
export enum ReportType {
  Corrections = 'corrections',
  FinancesSummary = 'finances-summary',
  FinancesSummaryReplenishment = 'finances-summary-replenishment',
  FinancesSummaryWriteOff = 'finances-summary-write-off',
  OrdersByClasses = 'goverment-cafeteria-orders-by-classes',
}

export type AnyReportType = ReportType | FinanceReportType

export const isReport = (val: any): val is ReportType => {
  return values(ReportType).includes(val)
}

export type ReportID = string

export type ReportParams = {
  reportID: ReportID
}

export type RequestParams = {
  formData: FormData
  reportType: AnyReportType
}
